export const NOTIFICATION_ROUTING = [
    {
        path: '/notification.html',
        name: 'notification',
        component: () => import('./Notification.vue'),
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Thông báo', icon: 'fa fa-bell' },
        ] },
        children: [],
    }
];